 
  $(document).ready(function () {
    $("[data-collage-toggle]").on("click", function () {
      let t = $(this).closest("[data-collage-item]");
      t.hasClass("open") ||
        $("[data-collage-item]")
          .removeClass("open")
          .find(".collage-content")
          .slideUp(200),
        t.toggleClass("open"),
        t.find(".collage-content").slideToggle(200);
    });
  });

 
  $(window).on("scroll", function () {
    $(".about-us-text-bg-image-box .common-box-container").each(function () {
      var t = $(window).scrollTop(),
        o = $(this).offset().top,
        e = $(this).outerHeight(),
        i = o - e;
      if (t + $(window).height() > o && t < o + e) {
        var s = -((t - i) * 0.12);
        767 > $(window).width() && (s = -((t - i) * 0.04)),
          $(this).css("background-position", "center " + s + "px");
      }
    });
  });



  
 


// 处理折叠
$(document).ready(function(){
$(".t4s-product__info-container .collage-item").each(function(){
 $(".t4s-product-form__buttons-box").before($(this));
})
})




function handleChangeVariant(currentVariant){

function showPrice(currentVariant){
console.log(currentVariant,"currentVariant");
let vid=currentVariant.id;
$(`.variant-price-box-${vid}`).addClass("active");
$(`.variant-price-box-${vid}`).siblings().removeClass("active");
}
function handleInTheBox(currentVariant){
// 判断logic_content_lists是否存在


console.log(logic_content_list,"logic_content_lists");
if(typeof logic_content_list !== 'undefined' && logic_content_list) {
  let option1 = currentVariant.option1;
  
  if(option1){
 
let mactValue = null;

for (let i = 0; i < logic_content_list.length; i++) {
  let obj = logic_content_list[i];
  if (obj.hasOwnProperty(option1)) {
    mactValue = obj[option1];
    break;
  }
}

console.log(mactValue,"mactValue");
$(`.in-the-box-right-box .item`).hide();
for(let i=0;i<mactValue.length;i++){
  let item=mactValue[i];
  console.log(item,"item");
  if(item == 0 || item == "0"){
 $(`.in-the-box-right-box .item-${i}`).hide();
  }else{
   $(`.in-the-box-right-box .item-${i} .num-box`).text(`x${item}`);
  $(`.in-the-box-right-box .item-${i}`).show();
  }
}
  }
}
}
showPrice(currentVariant);
handleInTheBox(currentVariant);
}



// 密码展示
$(document).ready(function(){
  $("body").on("click",".psw-option-box",function(){
    console.log($(this));
    $(this).toggleClass("active");
    $(this).closest('.t4s_field').find('input').attr("type", $(this).hasClass("active") ? "text" : "password");
  })
}) 
 


  $(document).ready(function(){
    function checkFormFilled($form) {
      // All visible, enabled input/textarea/select fields except hidden
      var $inputs = $form.find("input, textarea, select").filter(function() {
        var $el = $(this);
        // Exclude hidden fields and disabled fields
        if ($el.is(":hidden") || $el.is(":disabled")) return false;
        // If has 'required' attr, must be filled. If no 'required', still check
        return true;
      });
      var allFilled = true;
      $inputs.each(function(){
        var $el = $(this);
        if ($el.is('[type="checkbox"], [type="radio"]')) {
          // for checkbox/radio, at least one in group must be checked
          var name = $el.attr('name');
          // Only check for first in group
          if (name && $form.find('[name="'+name+'"]').length > 1) {
            var $group = $form.find('[name="'+name+'"]');
            if ($group.filter(':checked').length === 0) {
              allFilled = false;
              return false; // break
            }
          } else {
            if (!$el.is(':checked')) {
              allFilled = false;
              return false;
            }
          }
        } else if ($el.is('[type="file"]')) {
          if (!$el[0].files || $el[0].files.length === 0) {
            allFilled = false;
            return false;
          }
        } else {
          if (($el.val() || "").trim() === "") {
            allFilled = false;
            return false;
          }
        }
      });
      return allFilled;
    }

    function toggleAlreadyBoxForForm($form) {
      console.log($form,"$form");
      var $btns = $form.find('button[type="submit"], button.t4s_btn_submmit, button[type="button"].t4s_btn_submmit, button.t4s_btn_submmit');
      if (checkFormFilled($form)) {
        $btns.addClass('already-box');
      } else {
        $btns.removeClass('already-box');
      }
    }

    // 先循环计时器判断是否有#login_login-sidebar，再加载toggleAlreadyBoxForForm
    var loginSidebarCheckCount = 0;
    var loginSidebarCheckInterval = setInterval(function() {
      if ($('#login_login-sidebar').length > 0 || loginSidebarCheckCount > 30) {
        clearInterval(loginSidebarCheckInterval);
        $('form').each(function(){
          var $form = $(this);
          // Listen to input and change events on all fillable fields
          $form.on('input change', 'input, textarea, select', function() {
            toggleAlreadyBoxForForm($form);
          });
          // Also run on page load
          toggleAlreadyBoxForForm($form);
        });
      }
      loginSidebarCheckCount++;
    }, 100);
  });
 


   // 产品变体切换 - jQuery通用版（动态版，事件委托）
   $(document).on('click', '.new-product-card .color-dot', function() {
     var $variant = $(this);
     var $card = $variant.closest('.new-product-card');
     var $variants = $card.find('.color-dot');
     var $imageBox = $card.find('.image-box');
     $variants.removeClass('active');
     $variant.addClass('active');
     
     var variantId = $variant.data('variant-id');
     var $addToCartButton = $card.find('button[data-action-atc]');

     $addToCartButton.attr('data-variant-id', variantId);

     // 显示对应的变体图片，隐藏其他图片
     var $targetImageItem = $imageBox.find('.image-item-' + variantId);
     if ($targetImageItem.length > 0) {
       // 如果有对应的变体图片，显示它并隐藏其他
       $imageBox.find('.image-item').removeClass('active');
       $targetImageItem.addClass('active');
     } else {
       // 如果没有对应的变体图片，显示主图片
       $imageBox.find('.image-item').removeClass('active');
       $imageBox.find('.image-item:has(.main-featured-image)').addClass('active');
     }
   });